import React from 'react';
import jsonFormat from 'json-format';
import MarkDown from './MarkDown';

const formatConfig = {
  type: 'space',
  size: 2
};

function convertToMD(obj) {
  if (typeof obj === 'string') {
    try {
      obj = JSON.parse(obj);
    } catch (err) {
      obj = {};
    }
  }

  if (typeof obj !== 'object') {
    obj = {};
  }

  return '```json\n' + jsonFormat(obj, formatConfig) + '\n```';
}


export default function ({ json }) {
  return <MarkDown docs={convertToMD(json)} />
}